//#region [IMPORT]
import { useEffect, useState } from 'react';
import { onTask, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export const useTaskStatus = () => {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const [has_task, setHasTask] = useState(false);

  //#endregion

  useEffect( () => {
    //-----------------------------------------------------------------
    async function handleTask(data) {
      //-----------------------------------------------------------------
     if(data?.id) setHasTask(true) 
       else {
        setHasTask(false)
      };
    }
    onTask ( handleTask );
    
    return () => {
      removeListener( 'TASK' , handleTask );      
    };
   

  }, [] );

  return has_task;
}